import $http from '@/libs/axios'

class QueueAPI {
  public static async addReservation(body: any) {
    return (await $http.post('/queues/add-quest', body)).data
  }

  public static async checkAvailability(id: number) {
    return (await $http.post('/queues/check-availability', { id })).data
  }

  public static async getSettings(branchId: any) {
    return (await $http.get(`/queues/settings/${branchId}`)).data
  }

  public static async update(payload: any) {
    return (await $http.put('/queues/update', payload)).data
  }
}

export default QueueAPI
